import { Zip_7ZipIcon, Avi_Audio_VideoIcon, BarcdIcon, CadIcon, CeIcon, CrtfIcon, DatIcon, Doc_docxIcon, DwfIcon, DwgIcon, DxfIcon, EdsIcon, ExeIcon, FlvIcon, Hmibu_Hmibp_Hmibw_HmipuIcon, Html_HtmIcon, IcdIcon, IcoIcon, IduIcon, IdxIcon, IgsIcon, ImgIcon, IsoIcon, Lf24Icon, MhtIcon, MovIcon, Mp4Icon, MpgIcon, MsiIcon, PdfIcon, Ppt_PptxIcon, PrsntIcon, RarIcon, SecoIcon, Stp_StepIcon, TxtIcon, WmfIcon, WmvIcon, Xls_XlsxIcon, File_PlaceholderIcon, } from './icons';
export const knownTypes = {
  '7z': Zip_7ZipIcon,
  zip: Zip_7ZipIcon,
  avi: Avi_Audio_VideoIcon,
  audio: Avi_Audio_VideoIcon,
  video: Avi_Audio_VideoIcon,
  barcd: BarcdIcon,
  cad: CadIcon,
  ce: CeIcon,
  crtf: CrtfIcon,
  dat: DatIcon,
  dwf: DwfIcon,
  doc: Doc_docxIcon,
  docx: Doc_docxIcon,
  dwg: DwgIcon,
  dxf: DxfIcon,
  eds: EdsIcon,
  exe: ExeIcon,
  flv: FlvIcon,
  hmibu: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmibp: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmibw: Hmibu_Hmibp_Hmibw_HmipuIcon,
  hmipu: Hmibu_Hmibp_Hmibw_HmipuIcon,
  html: Html_HtmIcon,
  htm: Html_HtmIcon,
  icd: IcdIcon,
  ico: IcoIcon,
  idu: IduIcon,
  idx: IdxIcon,
  igs: IgsIcon,
  img: ImgIcon,
  iso: IsoIcon,
  lf24: Lf24Icon,
  mht: MhtIcon,
  mov: MovIcon,
  mp4: Mp4Icon,
  mpg: MpgIcon,
  msi: MsiIcon,
  pdf: PdfIcon,
  ppt: Ppt_PptxIcon,
  pptx: Ppt_PptxIcon,
  prsnt: PrsntIcon,
  rar: RarIcon,
  seco: SecoIcon,
  stp: Stp_StepIcon,
  step: Stp_StepIcon,
  txt: TxtIcon,
  wmf: WmfIcon,
  wmv: WmvIcon,
  xls: Xls_XlsxIcon,
  xlsx: Xls_XlsxIcon,
  placeholder: File_PlaceholderIcon,
};
